import React from "react";

const TrustpilotComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default TrustpilotComponent;
